'use client';

import { useRouter } from 'next/navigation';

import { goBackOrHome } from '@/utilities/goBackOrHome';

import { ArrowRight } from 'iconsax-react';

const BackButton = () => {
    const router = useRouter();

    return <ArrowRight color='currentcolor' className='cursor-pointer' size={24} onClick={() => goBackOrHome(router)} />;
};

export default BackButton;
